export default __webpack_public_path__ + "static/media/QSGRW_Search_Type.8c204429.png";